import axios from '@/utils/request'

/* 游戏分类 */
export function gameType(data) {
  return axios({
    url: '/game/game_type',
    method: 'post',
    data: data
  })
}
/* 游戏属性 */
export function gameAttr(data) {
  return axios({
    url: '/game/attribute_list',
    method: 'post',
    data: data
  })
}
// 游戏列表

export function gameList(url, data) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

// 游戏排名列表

export function topList(url, data) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

// 盒子

export function gameBox(data) {
  return axios({
    url: '/game/game_box',
    method: 'post',
    data: data
  })
}

// 刷新短链

export function resetUrl(data) {
  return axios({
    url: '/game/game_box_reset_url',
    method: 'post',
    data: data
  })
}

// 查看代充分成
export function gameChargeProfit(data) {
  return axios({
    url: '/game/game_charge_profit',
    method: 'post',
    data: data
  })
}

// 盒子重新生成短链（新）
export function newResetUrl(data) {
  return axios({
    url: '/game/reset_short_url',
    method: 'post',
    data: data
  })
}

// 一键分包
export function onekey_pack(data) {
  return axios({
    url: '/game/onekey_pack',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/extension.js